export const CARS_STATE = "CARS";
const BATTERY_PART_ICON = 7;
export const BATTERY_ONE_PART = 100 / BATTERY_PART_ICON;
